import { Component, Input } from '@angular/core';
import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatSpinner } from '@angular/material/progress-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-careersjdview',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatChipsModule,
    MatIconModule,
    MatButtonModule,
    MatSpinner,
    TranslateDirective
  ],
  templateUrl: './careersjdview.component.html',
  styleUrl: './careersjdview.component.scss',
})
export class CareersjdviewComponent {
  @Input() apiEndPoint!: string;
  @Input() websiteId!: string;
  @Input() pageId!: string;
  jobDetails: any = null;
  loading = true;
  error: string | null = null;
  jobId: string | null = null;

  jdContent: string = '';
  jdLoading: boolean = false;
  jdError: string | null = null;
  accessUrl = environment.ASSET_BLOB_URL;
  containerName = environment.ASSET_CONTAINER + '/';
  base_url = this.accessUrl.split('.net/')[0] + '.net/';

  constructor(
    private apiservices: ApiservicesService,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.jobId = this.route.snapshot?.paramMap.get('id');
    this.websiteId = this.route.snapshot?.paramMap.get('websiteId') || '';
    this.pageId = this.route.snapshot?.paramMap.get('pageId') || '';
    if (this.jobId) {
      this.getJobDetails(this.jobId);
    } else {
      this.error = 'No job ID provided';
      this.loading = false;
    }
  }

  getJobDetails(id: string) {
    this.loading = true;
    this.apiservices.getCareersList(this.websiteId, this.pageId, id).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res?.data) {
          this.jobDetails = res.data;
          this.loadJdContent(this.jobDetails.jd_url);
        } else if (res?.rows?.length) {
          const matchedJob = res.rows.find(
            (job: any) => job.id === id || job.id === Number(id)
          );
          if (matchedJob) {
            this.jobDetails = matchedJob;
            this.loadJdContent(matchedJob.jd_url);
          } else {
            this.error = `No matching job found for ID: ${id}`;
          }
        } else {
          this.error = 'No job details available';
        }
      },
      error: (err) => {
        this.loading = false;
        this.error = 'Failed to load job details';
        console.error('Error fetching job details:', err);
      },
    });
  }

  goBack() {
    window.history.back();
  }

  loadJdContent(jdUrl: string) {
    if (!jdUrl) {
      this.jdError = 'No JD file available';
      return;
    }

    this.jdLoading = true;
    this.jdError = null;

    const fullUrl = `${this.base_url}${this.containerName}${jdUrl}`;

    this.http.get(fullUrl, { responseType: 'text' }).subscribe({
      next: (content) => {
        this.jdContent = content;
        this.jdLoading = false;
      },
      error: (err) => {
        this.jdError = 'Failed to load job description file';
        this.jdLoading = false;
        console.error('Error loading JD file:', err);
      },
    });
  }

  getEmploymentType(typeId: number): string {
    switch (typeId) {
      case 32:
        return 'Full-time';
      default:
        return 'Unknown';
    }
  }
}
